import React, { useEffect, useState, forwardRef } from 'react';
import { observer } from 'mobx-react-lite';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

import { useAnalytics } from '../../utils/analytics';
import { ActionName } from '../../utils/mobileApp/mobileApp.types';

import { useMst } from '../../models/rootModel';

import { GroupList } from './PickAGroupStep/GroupList';
import { PickAGroupStepProps } from './PickAGroupStep/pickAGroupStep.types';

export const SinglePagePickAGroup = observer((props: PickAGroupStepProps) => {
  const { Group, UserDiscoveryResponse, Step, UserProgress } = useMst();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [pickedGroupId, setPickedGroupId] = useState('');
  const [open, setOpen] = useState(false);

  const analytics = useAnalytics();

  useEffect(() => {
    Group.getUserGroupsByDiscovery();
    Group.getUserCurrentGroups();
  }, [Group]);

  const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleClose = () => {
    setOpen(false);
    UserProgress.goToApp({ action: ActionName.Added_Group, groupId: pickedGroupId });
  };

  const goNext = (groupId: string) => {
    setPickedGroupId(groupId);
    setOpen(true);
    UserDiscoveryResponse.assignUserToGroup({ groupInstanceId: groupId })
      .then((res) => {
        setIsButtonDisabled(true);
        if (res.kind === 'ok') {
          const group = Group.getGroup(groupId);
          analytics.track(`click confirm choose a circle`, {
            stepId: props.id,
            stepType: props.type,
            groupInstanceId: groupId,
            facilitator: group?.leaderName,
            ...UserDiscoveryResponse.utms,
            origin: Step.origin,

            segment: UserDiscoveryResponse.segment,
            oldGroupInformation: Group.oldGroups,
          });

          handleClose();
          return;
        }
        throw new Error(res.data);
      })
      .catch((error) => console.log('error', error));
  };

  return (
    <>
      {props.isActive && Group.groups.length > 0 ? (
        <GroupList openGroupPopUp={goNext} {...props} isButtonDisabled={isButtonDisabled} />
      ) : null}
      <Snackbar
        open={open}
        autoHideDuration={1500}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
          You joined a new group!{' '}
        </Alert>
      </Snackbar>
    </>
  );
});
